'use client'

import { useFlipperChatState } from '@dolfin/hooks/state/flipper-chat'
import { t } from '@lingui/core/macro'
import { Button } from 'react-aria-components'
import FlipperAvatarSimple from './FlipperAvatarSimple'

const FlipperChatButton = () => {
  const toggle = useFlipperChatState(s => s.toggle)

  return (
    <span
      className='group/flipper-chat mb-4 text-neutral-700 md:text-neutral-100 pl-[0.45rem] group-hover:pl-2 transition-all duration-300 flex items-center h-10'
      style={{ transitionDelay: `150ms` }}>
      <Button
        onPress={toggle}
        aria-label={t`Open Flipper AI chat`}
        className='flex items-center gap-2 w-full'>
        <FlipperAvatarSimple
          size='m'
          className='transition-all duration-300 delay-100 group-hover:w-6 group-hover:h-6 group-hover/flipper-chat:!w-8 group-hover/flipper-chat:!h-8 group-hover/flipper-chat:drop-shadow-[0_4px_6px_rgba(236,72,153,0.5)]'
          overDark
          followMouseAnimation
          waveAnimation
        />
        <p
          className={
            'md:hidden md:group-hover:block text-xs font-medium whitespace-nowrap overflow-hidden'
          }>
          Flipper AI
        </p>
      </Button>
    </span>
  )
}

export default FlipperChatButton
